import { useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useScrollToTop = () => {
  const { pathname } = useLocation();

  // Use useLayoutEffect to scroll before paint, preventing flash of wrong scroll position
  // Fall back to useEffect for SSR compatibility
  const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;

  useIsomorphicLayoutEffect(() => {
    // Use requestAnimationFrame to ensure DOM has updated before scrolling
    // This fixes issues where scroll happens before React finishes rendering
    requestAnimationFrame(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    });
  }, [pathname]);
};
